import React, { Component } from 'react';

export default class ColorItem extends Component {
    render(){
        return <span>
                <div 
                    title={this.props.color} 
                    tabIndex="0" 
                    style={{background: this.props.color, height: "16px", width: "20px", cursor: "pointer", 
                        position: "relative", outline: "none", marginBottom: "1px", marginLeft:"5px",marginRight:"5px", overflow: "hidden", 
                        borderRadius: "2px 2px 0px 0px"}}>
                    <div 
                        style={{fill: "rgb(255, 255, 255)", marginLeft: "8px", display: "none"}}>
                        <svg viewBox="0 0 24 24" style={{width: "24px", height: "24px"}}>
                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path>
                        </svg>
                    </div>
                </div>
            </span>
    }
}


// WEBPACK FOOTER //
// ./src/components/color-block/ColorItem.jsx